import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import StarIcon from '@mui/icons-material/Star';

const FloatingFeedbackButton = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'fixed',
        right: '-15px',
        margin: '0',
        padding: '0',
        top: '75%',
        transform: 'translateY(-50%)',
        zIndex: 1200,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // gap: 1,
      }}
    >
      {/* Circular background highlight */}
      <Box
        sx={{
          position: 'absolute',
          width: { xs: '60px', sm: '70px', md: '80px' },
          height: { xs: '60px', sm: '70px', md: '80px' },
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          zIndex: -1,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />

      <Button
        variant="contained"
        onClick={() => navigate('/feedback')}
        sx={{
          fontWeight: 700,
          fontSize: { xs: '0.8rem', sm: '0.7rem', md: '0.8rem' },
          color: '#ffffff',
          letterSpacing: '0.3px',
          textTransform: 'none',
          px: { xs: 1.8, sm: 2, md: 2.2 },
          py: { xs: 2.2, sm: 2.5, md: 2.8 },
          borderRadius: '10px',
          background: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)',
          boxShadow: '0 4px 15px rgba(255, 107, 53, 0.4)',
          animation:
            'pulseGlowVertical 2s ease-in-out infinite, bounceVertical 2s ease-in-out infinite',
          transition: 'all 0.3s ease',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          transform: 'rotate(-90deg)',
          transformOrigin: 'center',
          whiteSpace: 'nowrap',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.6,
          minWidth: 'auto',
          width: 'auto',
          height: '50px',
          position: 'relative',
          '&:hover': {
            background: 'linear-gradient(135deg, #FF5722 0%, #FF6B35 100%)',
            boxShadow: '0 6px 20px rgba(255, 107, 53, 0.6)',
            transform: 'rotate(-90deg) scale(1.05)',
          },
          '@keyframes pulseGlowVertical': {
            '0%, 100%': {
              boxShadow: '0 4px 15px rgba(255, 107, 53, 0.4)',
            },
            '50%': {
              boxShadow:
                '0 4px 25px rgba(255, 107, 53, 0.7), 0 0 30px rgba(255, 107, 53, 0.3)',
            },
          },
          '@keyframes bounceVertical': {
            '0%, 100%': {
              transform: 'rotate(-90deg) translateX(0)',
            },
            '50%': {
              transform: 'rotate(-90deg) translateX(-3px)',
            },
          },
        }}
      >
        <Typography
          component="span"
          sx={{
            fontSize: 'inherit',
            fontWeight: 'inherit',
            color: 'inherit',
            lineHeight: 1.2,
            display: 'block',
          }}
        >
          Share Feedback
        </Typography>
        {/* <StarIcon
          sx={{
            fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
            color: '#ffffff',
          }}
        /> */}
      </Button>
    </Box>
  );
};

export default FloatingFeedbackButton;
